import { loaderAction, setInvoiceSumFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const GetInvoiceSumByIdThunk = (args) => async (dispatch, getState) => {
    const { user } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('invoice_id', args.invoice_id);

        const response = await api({ data: formData, link: 'get_invoice_sum_by_id' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setInvoiceSumFormAction(response.data));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};